import { Component } from "react";

import { AppProvider, Layout, Page, Frame } from "@shopify/polaris";

import "./index.css";
import translations from "@shopify/polaris/locales/en.json";

class PrivacyPolicy extends Component {
  state = {};

  // 进入组件调用
  componentDidMount() {
    // 设置页面标题
    document.title = "DropshipMan";
  }

  render() {
    return (
      <div className="home_loading_page">
        <AppProvider i18n={translations}>
          <Frame>
            <Page>
              <Layout>
                <div id="loading-state" role="alert" aria-live="assertive">
                  <div className="message">
                    <img
                      src="/new-product/loadingDsmText.svg"
                      alt="Dropshipman Splash screen"
                      width="120"
                      height="120"
                    />
                    <p>
                      Welcome to Dropshipman, please wait patiently for the
                      loading to complete
                      <span className="place-text">
                        A trustworthy cross-border e-commerce platform, printing
                        on demand, and providing solutions for excellent
                        cross-border e-commerce Tired of common cross-border
                        e-commerce challenges such as unreliable suppliers, slow
                        shipping, poor quality, and low profits? Now with
                        Dropshipman: Easily import products from AliExpress and
                        leverage popular platforms like Oberlo, CJDropshipping,
                        Zendrop, DSers, Shopmaster, ChinaBrands and Topdser, our
                        comprehensive solution simplifies the entire process.
                        Stay ahead of the curve, find hot and winning products,
                        and find reliable suppliers. While maximizing your
                        business potential.
                      </span>
                    </p>
                    <div className="content">
                      <div className="spinner_page">
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </Layout>
            </Page>
          </Frame>
        </AppProvider>
      </div>
    );
  }
}

export default PrivacyPolicy;
